import { Box, BoxProps } from '@chakra-ui/react'
import { useMemo } from 'react'
import { colors } from '../theme/cssVariables'

interface ClipBoxProps extends BoxProps {
  borderColor?: string
  clipSize?: string // 控制裁剪大小
}

const ClipBox = ({ borderColor, clipSize = '7%', background, children, ...rest }: ClipBoxProps) => {
  // 计算裁剪路径
  const clipPath = useMemo(() => {
    return `polygon(
      0 0, 
      100% 0, 
      100% calc(100% - ${clipSize}), 
      calc(100% - ${clipSize}) 100%, 
      0 100%
    )`
  }, [clipSize])

  return (
    <Box
      pos="relative"
      background={background}
      clipPath={clipPath}
      border={`1px solid ${borderColor ?? background}`}
      _after={{
        content: '""',
        position: 'absolute',
        right: '0',
        bottom: '0',
        width: '7%',
        height: '7%',
        backgroundColor: borderColor ?? background ?? colors.colorA2,
        clipPath: 'polygon(0 100%, 100% 0, 100% 100%)',
        pointerEvents: 'none',
      }}
      display={'flex'}
      alignItems={'center'}
      justifyContent={'center'}
      {...rest}
    >
      {children}
    </Box>
  )

  // 如果有borderColor，渲染双层结构
  // if (borderColor) {
  //   return (
  //     <Box position="relative" width={width} height={height} {...rest}>
  //       {/* 外层边框 */}
  //       <Box
  //         position="absolute"
  //         top="-1px"
  //         left="-1px"
  //         width="calc(100% + 2px)"
  //         height="calc(100% + 2px)"
  //         background={borderColor}
  //         clipPath={clipPath}
  //       />
  //       {/* 内层内容 */}
  //       <Box background={'#000'} clipPath={clipPath} width="100%" height="100%">
  //         <Box
  //           position="relative"
  //           width="100%"
  //           height="100%"
  //           background={background}
  //           clipPath={clipPath}
  //           display={'flex'}
  //           alignItems={'center'}
  //           justifyContent={'center'}
  //           {...rest}
  //         >
  //           {children}
  //         </Box>
  //       </Box>
  //     </Box>
  //   )
  // }

  // // 如果没有borderColor，渲染单层结构
  // return (
  //   <Box
  //     width={width}
  //     height={height}
  //     background={background}
  //     clipPath={clipPath}
  //     display={'flex'}
  //     alignItems={'center'}
  //     justifyContent={'center'}
  //     {...rest}
  //   >
  //     {children}
  //   </Box>
  // )
}

export default ClipBox
